import { render, staticRenderFns } from "./HeaderSummary.vue?vue&type=template&id=5f0f2a62&scoped=true&"
import script from "./HeaderSummary.vue?vue&type=script&lang=js&"
export * from "./HeaderSummary.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSummary.vue?vue&type=style&index=0&id=5f0f2a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f2a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VLayout})
